import { Component, OnInit } from '@angular/core';
import { PromotionAction } from 'src/app/models/promotionAction.model';
import { SebbieTask } from 'src/app/models/sebbietask.model';
import { StreApperInfo } from 'src/app/models/streapper-info.model';
import { AuthService } from 'src/app/services/auth.service';
import { SebbieService } from 'src/app/services/sebbie.service';
import { StreappEventsService } from 'src/app/services/streapp-events.service';

@Component({
    selector: 'task-detail',
    templateUrl: './task-detail.component.html',
    styleUrl: './task-detail.component.scss',
    standalone: false
})
export class TaskDetailComponent implements OnInit {
  profile: StreApperInfo;
  currentPromotionAction: PromotionAction;
  availableTasks: Array<SebbieTask>;
  availableTasksIds: string[];
  spotsReceived: number = 0;

  loading: boolean = true;
  error: boolean = false;

  constructor(
    private readonly authService: AuthService,
    private readonly streappService: StreappEventsService,
    private readonly sebbieService: SebbieService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.loadData();
    this.loading = false;
  }

  numberOfTimesTaskCompleted(taskId: string): number {
    var task = this.profile.completedSebbieTasks.find(task => task.id === taskId);
    if(!task){
      return 0;
    }
    return task.completedCount;
  }

  async loadData(): Promise<void> {
    this.profile = await this.getStreapperInfo();
    this.currentPromotionAction = await this.getCurrentPromotionAction();
    this.availableTasks = await this.getAvailableTasks();
    this.availableTasksIds = this.availableTasks.map(task => task.id);

    if(this.profile != null && this.availableTasks != null && !this.error) {
      this.profile.completedSebbieTasks.forEach(completedTask => {
        if(this.availableTasks.some(task => task.id === completedTask.id && completedTask.completedCount != undefined)) {
          this.spotsReceived += completedTask.reward * completedTask.completedCount;
        }
      });
    }
  }

  async getStreapperInfo(): Promise<StreApperInfo> {
    try {
      const profile = await this.streappService.getStreapperInfoId(this.authService.userId);
      return profile;
    } catch (error: Error | any) {
      this.error = true;
      console.error('Error fetching Streapper info:', error);
    }
    return null;
  }

  async getCurrentPromotionAction(): Promise<PromotionAction> {
    try {
      const promotionAction = await this.sebbieService.getCurrentPromotionAction(this.authService.authorizationHeaderValue);
      return promotionAction;
    } catch (error: Error | any){
      this.error = true;
      console.error('Error fetching current promotion action:', error);
    }
    return null;
  }

  async getAvailableTasks(): Promise<Array<SebbieTask>> {
    try {
      const tasks = await this.sebbieService.getCurrentPromotionActionTasks(this.authService.authorizationHeaderValue);
      return tasks;
    } catch (error: Error | any) {
      this.error = true;
      console.error('Error fetching available tasks:', error);
    }
    return [];
  }
}
